import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { BinCardProvider } from '../centerWarehouse/binCard/ContextAPI';
import Index from '../centerWarehouse/binCard/Index';
import PermissionDenied from './PermissionDenied';

export default function CenterBinCard() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['center-bin-card']) return <PermissionDenied />;

    return (
        <BinCardProvider>
            <Index />
        </BinCardProvider>
    );
}
